import SEOHead from "@/components/General/SEOHead";
import About from "@/modules/About/About";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const AboutPage = () => {
  return (
    <>
      <SEOHead />
      <About />
    </>
  );
};
export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});
export default AboutPage;
